import { css } from "styled-components";

const cardStyle = css`
	font-size: 0.83rem;
	padding: 0.25rem;
	border-bottom: 1px solid var(--border-color);
`;

export default cardStyle;
